import React from 'react'
import {Skeleton,CardSkeletonContainer} from './style'

type CardSkeletonProps = {
    cards?:number,
    width?:number,
    height?:number,
    showAsGrid?:boolean,
}

const CardSkeleton = ({cards=1,width=100,height=100,showAsGrid=false}:CardSkeletonProps) =>{

    let arrayCards = new Array(cards).fill(0);
    
    return (
        <CardSkeletonContainer>
        {   
            arrayCards.map((_, index)=>{                
                return <Skeleton key={index.toString()} width={width} height={height} showAsGrid={showAsGrid}/>
            })
        }
        </CardSkeletonContainer>
    );


}

export default CardSkeleton;